<script setup>
import { vMaska } from "maska";

const props = defineProps({
	type: {
		type: String,
		required: true,
	},
	placeholder: {
		type: String,
		default: "",
	},
	mask: {
		type: String,
		default: "",
	},
	inputId: {
		type: String,
		default: "",
	},
	isLabel: {
		type: Boolean,
		default: false,
	},
	isRequired: {
		type: Boolean,
		required: true,
	},
	wrapperClass: {
		type: String,
		default: "",
	},
	name: {
		type: String,
		default: "",
	},
	bindName: {
		type: Object,
		default() {
			return {};
		},
	},
});
</script>

<template>
	<div class="i-input-wrapper" :class="wrapperClass">
		<input
			:id="inputId"
			v-bind="bindName"
			v-maska
			class="i-input"
			:type="type"
			:data-maska="mask"
			:name="name"
			placeholder=" "
			@focus="$emit('focused')"
		/>
		<label
			v-if="isLabel"
			class="i-input-label"
			:class="{ 'i-input-label_required': isRequired }"
			:for="inputId"
		>
			{{ placeholder }}
		</label>
	</div>
</template>

<style scoped lang="scss">
@import "frontend/web/src/styles/utils/variables.scss";
@import "./i-input.scss";
</style>
